enum ActionTypes {
  SET_DASHBOARD_HOTEL_ID = 'dashboard/SET_DASHBOARD_HOTEL_ID',
  FETCH_DASHBOARD_HOTEL_INFO = 'dashboard/FETCH_DASHBOARD_HOTEL_INFO',
  FETCH_DASHBOARD_HOTEL_INFO_SUCCESS = 'dashboard/FETCH_DASHBOARD_HOTEL_INFO_SUCCESS',
  FETCH_DASHBOARD_HOTEL_INFO_FAILURE = 'dashboard/FETCH_DASHBOARD_HOTEL_INFO_FAILURE',
}

export default ActionTypes;
